import { render, staticRenderFns } from "./AssetsFull.vue?vue&type=template&id=f2b3ad44"
import script from "./AssetsFull.vue?vue&type=script&lang=js"
export * from "./AssetsFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports